export default {
    ADD_NETWORK: 'ADD_NETWORK',
    EDIT_NETWORK: 'EDIT_NETWORK',
    DELETE_NETWORK: 'DELETE_NETWORK',
    UPDATE_FULL_NETWORKS: 'UPDATE_FULL_NETWORKS',
    RESET_NETWORKS: "RESET_NETWORKS"
};
